import { useMsal } from '@azure/msal-react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { FC, useEffect, useState } from 'react';

import { Card } from '@mui/material';
import { VITE_AZURE_AUTH_TENANT_ID } from '@src/main/env';
import { Embed, models, Report as ReportType } from 'powerbi-client';

import { useError } from '@src/main/ui/components/common/error/hooks/useError';
import styles from './Report.module.scss';

interface Props {
  id: string;
}

export const Report: FC<Props> = ({ id }) => {
  const { instance, accounts } = useMsal();
  const { addError } = useError();
  const [, setReport] = useState<ReportType>();
  const [accessToken, setAccessToken] = useState<string | undefined>(undefined);

  useEffect(() => {
    instance
      .acquireTokenSilent({
        scopes: ['https://analysis.windows.net/powerbi/api/.default'],
        account:
          accounts.filter((account) => account.tenantId === VITE_AZURE_AUTH_TENANT_ID).at(0) ??
          accounts[0],
      })
      .then(({ accessToken: token }) => {
        setAccessToken(token);
      })
      .catch(addError);
  }, [accounts, addError, instance]);

  return (
    <Card sx={{ height: '100%' }}>
      <PowerBIEmbed
        cssClassName={styles.report}
        embedConfig={{
          settings: {
            layoutType: models.LayoutType.Custom,
            customLayout: {
              displayOption: models.DisplayOption.FitToPage,
            },
            bars: {
              actionBar: {
                visible: true,
              },
            },
            personalBookmarksEnabled: true,
            panes: {
              pageNavigation: {
                visible: true,
                position: models.PageNavigationPosition.Left,
              },
            },
          },
          type: 'report',
          id,
          embedUrl: 'https://app.powerbi.com/reportEmbed',
          accessToken,
          tokenType: models.TokenType.Aad,
          permissions: models.Permissions.Read,
        }}
        getEmbeddedComponent={(embedObject: Embed) => {
          setReport(embedObject as ReportType);
        }}
      />
    </Card>
  );
};
